/*  ==========================================================================
    VARIABLES
    Global variables for the whole project.

    INFO:
    - the "ts" object is coming from the ts2js converter
    - translations MUST NOT be defined here, generally don't make translations
     in javascript!
    - contributions for the kickstarter are welcome!
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from "jquery";

/*
 * TS CONSTANTS
 */

// get typo3 constants
export const ts = BN.lang.constants || {};

/*
 * CUSTOM
 */

// dynamic domain
let splittedUrl = window.location.href.split('/');
export const domain = splittedUrl[0] + '//' + splittedUrl[2];

// language
export const lang = ts.lang.cur.locale;
export const lang_id = ts.lang.cur.uid;

// ehotelier
export const eh_hid = ts.ehotelier.hotel_id;
export const eh_pid = ts.ehotelier.portal_id;

//weather
export const weather_country = ts.weather.country;
export const weather_location = ts.weather.location;
export const weather_provider = ts.weather.provider;

// cache buster
let cb_day = new Date().getDate(),
    cb_hour = new Date().getHours(),
    cb_month = new Date().getMonth() + 1,
    cb_year = new Date().getFullYear();
export const cacheBuster = cb_year +''+ cb_month +''+ cb_day +''+ cb_hour;

// files
export const css_global = {
    bn_icons: '/typo3conf/ext/bn_typo_dist/Resources/Public/admin/assets/icons/brandnamic/style.css',
    eh_icons: 'https://cdn.bnamic.com/brandnamic_files/ehotelier-icons/style.css',
    iconamic: 'https://cdn.bnamic.com/brandnamic_files/powered_by/icons/style.css',
    weather_icons: '/typo3conf/ext/bn_typo_dist/Resources/Public/admin/assets/icons/weather/style.css'
};
export const js_global = {
};
export const js_vimeoPlayerApi = 'https://player.vimeo.com/api/player.js';
export const js_youtubeIframeApi = 'https://www.youtube.com/iframe_api';

// fonts
export const fonts = [
    'Lato:300,400,700'
];

// main areas
export const $html = $('html');
export const $head = $('head');
export const $body = $('body');
export const $page = $body.find('#bn-page');
export const $p_header = $page.find('#bn-header');
export const $p_mobileHeader = $page.find('#bn-mobile-header');
export const $p_vista = $page.find('#bn-vista');
export const $p_main = $page.find('#bn-main');
export const $p_footer = $page.find('#bn-footer');
export const $p_scrollUp = $page.find('#bn-scroll-up');
export const $p_quickRequestV1 = $page.find('#bn-quick-request--v1');
export const $p_quickRequestV2 = $page.find('#bn-quick-request--v2');
export const $p_ehotelierPopUp = $page.find('#bn-ehotelier-pop-up');

// waypoints
export const $wp_1 = $p_main.find('.bn-waypoint--1');
export const $wp_2 = $p_main.find('.bn-waypoint--2');

// cookie banner
// default elements
export const default_loader = '<div class="bn-loader"><i class="bn-icon bn-icon--loader"></i></div>';
// export const default_noEntries = '<div class="bn-no-result hidden">'+ts.default.no_entries+'</div>';
export const default_noEntries = '<div class="bn-no-result bn-no-result-more hidden"><div class="bn-no-result-more__notice"><div class="bn-no-result-more__title">'+ts.default.no_entries_offers_custom+'</div><div class="bn-no-result-more__subtitle">'+ts.default.no_entries_offers_custom_sub+'</div></div><a href="'+document.querySelector("meta[name='inquiry-path']").getAttribute("content")+'" class="bn-no-result-more__button">'+ts.text.inquire+'</a></div>';
// slick carousel arrows
export const slick_nextArrow = '<div class="bn-arrows__arrow bn-arrows__arrow-next"><i class="bn-icon bn-icon--arrow-right"></i></div>';
export const slick_prevArrow = '<div class="bn-arrows__arrow bn-arrows__arrow-prev"><i class="bn-icon bn-icon--arrow-left"></i></div>';
export const slick_nextArrowV2 = '<div class="bn-arrows__arrow bn-arrows__arrow-next"><i class="bn-icon bn-icon--arrow-bordered-right"></i></div>';
export const slick_prevArrowV2 = '<div class="bn-arrows__arrow bn-arrows__arrow-prev"><i class="bn-icon bn-icon--arrow-bordered-left"></i></div>';

// dynforms
export const dynformsGlobalConfig = {
    baseUrl: "https://admin.ehotelier.it",
    hotelId: ts.ehotelier.hotel_id,
    lang: lang,
    portalId: 0,
    buttonTypes: 0,
    urlPrivacy: '/index.php?id=' + ts.pids.privacy + '&L='+lang_id,
    instantValidation: true,
    validationBaseUrl: 'https://admin.ehotelier.it',
    fieldHide: {
        consent_profiling: !parseInt(ts.ehotelier.consent_profiling)
    }
};
export const dynformsColors = {
    colorPRIMARY: '#003e54',
    colorSECONDARY: '#fff',
    colorACTION: '#ff6200',
    colorTEXT: '#626262',
    colorValid: '#008000',
    colorError: '#ff0000',
};


// WEBPACK FOOTER //
// ./source/js/globals/variables.js